export function addMinutesToTime(hhmm, mins) {
  const [h, m] = hhmm.split(":").map(Number);
  const total = h * 60 + m + mins;
  return `${String(Math.floor(total / 60) % 24).padStart(2, "0")}:${String(total % 60).padStart(2, "0")}`;
}

export const WEEKDAYS = ["Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado", "Domingo"];
const MONTHS = ["enero","febrero","marzo","abril","mayo","junio","julio","agosto","septiembre","octubre","noviembre","diciembre"];

export function fmtDateLong(iso) {
  // iso = "2026-06-20"
  const [y, m, d] = iso.split("-").map(Number);
  const dt = new Date(y, m - 1, d);
  const wd = WEEKDAYS[(dt.getDay() + 6) % 7];
  return `${wd}, ${d} de ${MONTHS[m - 1]}`;
}

export function fmtDateShort(iso) {
  const [, m, d] = iso.split("-").map(Number);
  return `${String(d).padStart(2, "0")}/${String(m).padStart(2, "0")}`;
}

export function fmtDateTime(iso) {
  if (!iso) return "";
  const dt = new Date(iso);
  if (isNaN(dt)) return "";
  const d = String(dt.getDate()).padStart(2, "0");
  const m = String(dt.getMonth() + 1).padStart(2, "0");
  const hh = String(dt.getHours()).padStart(2, "0");
  const mm = String(dt.getMinutes()).padStart(2, "0");
  return `${d}/${m} ${hh}:${mm}`;
}

function fmtLocal(dt) {
  const y = dt.getFullYear();
  const m = String(dt.getMonth() + 1).padStart(2, "0");
  const d = String(dt.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

export function todayISO() {
  return fmtLocal(new Date());
}

export function addDays(iso, n) {
  const [y, m, d] = iso.split("-").map(Number);
  const dt = new Date(y, m - 1, d);
  dt.setDate(dt.getDate() + n);
  return fmtLocal(dt);
}

export function mondayOf(iso) {
  const [y, m, d] = iso.split("-").map(Number);
  const dt = new Date(y, m - 1, d);
  const diff = (dt.getDay() + 6) % 7; // 0 if Monday
  dt.setDate(dt.getDate() - diff);
  return fmtLocal(dt);
}

export function weekDays(mondayIso) {
  return Array.from({ length: 7 }, (_, i) => addDays(mondayIso, i));
}

export function dayNumber(iso) {
  return Number(iso.split("-")[2]);
}

export function shortMonth(iso) {
  const m = Number(iso.split("-")[1]);
  return ["ene","feb","mar","abr","may","jun","jul","ago","sep","oct","nov","dic"][m - 1];
}

export function groupByDate(slots) {
  const map = {};
  slots.forEach((s) => { (map[s.date] = map[s.date] || []).push(s); });
  return Object.keys(map).sort().map((date) => ({ date, slots: map[date] }));
}
